import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { parse } from 'qs';
import { actions } from '../redux';
import FSFlatButton from '../../../src/components/lib/FSFlatButton';
import componentBase from '../../../src/lib/component-base';
import { isValidEmail } from '../../../src/helpers/Validators';
import { addMetaCanonical } from '../../../shared/lib/meta-tags';
import IconHeader from '../../../shared/components/IconHeader/IconHeader';
import TextInput from '../../../shared/components/TextInput/TextInput';

import KeyIconWHITE from '../../../static/images/Key-Icon-WHITE.svg';

const errorDisplayWording = (code) => {
  const val = code.general ? code.general : code;
  const wordings = {
    INVALID_PASSWORD: { message: 'Invalid email/password combination', type: 'email' },
    MISSING_EMAIL: { message: 'The email address provided is invalid', type: 'email' },
    INVALID_EMAIL: { message: 'The email address provided is invalid', type: 'email' },
    PASSWORD_REQUIRED: { message: 'A password must be provided', type: 'password' },
    UNKNOWN_USER: { message: 'There is no account associated with the user', type: 'email' },
    UNKNOWN_ERROR: { message: 'Error', type: 'email' },
  };

  return wordings[val] || { message: 'Error: Login temporarily unavailable', type: 'email' };
};

const iconHeaderIconStyle = {
  height: '47px',
  width: '47px',
  margin: '12px 10px 12px 25px',
};

const textInputLabelStyle = {
  textAlign: 'left',
};

const textInputLabelErrorStyle = {
  float: 'left',
  top: '5px',
};

const textInputSpanStyle = {
  color: 'white',
};

const textInputInputStyle = {
};

const parseQs = qs => parse(qs, { ignoreQueryPrefix: true });

@connect(
  state => ({
    user: state.Account.user,
    loggedIn: state.Account.loggedIn,
    loginError: state.Account.loginError,
  }),
  actions,
)
@componentBase('Login')
export default class Login extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    user: PropTypes.object,
    resetAuthState: PropTypes.func,
    location: PropTypes.object,
    login: PropTypes.func,
    logout: PropTypes.func,
    loginError: PropTypes.array,
    loggedIn: PropTypes.bool,
    routerPush: PropTypes.func,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      validEmailStyle: null,
    };

    this.parsedQs = parseQs(props.location.search);

    this.redirected = false;

    this.setRef = this.setRef.bind(this);

    // refs
    this.email = null;
    this.password = null;
    this.rememberMe = null;
  }

  componentDidMount() {
    this.props.resetAuthState();
  }

  componentWillReceiveProps(nextProps) {
    if (!this.redirected && nextProps.loggedIn) {
      let destination = '/';

      const qs = parseQs(nextProps.location.search);

      if (qs.destination) {
        destination = qs.destination;
      } else if (nextProps.user && !nextProps.user.verified) {
        destination = '/account/verify';
      }

      this.redirected = true;
      this.props.resetAuthState();
      this.props.routerPush(destination);
    }
  }

  onEnterKeyPress = (e) => {
    if (e.charCode === 13) {
      this.handleSubmit(e);
    }
    this.lastKeyPressed = e.charCode;
  };

  getMetaTags = () => {
    const title = 'FlightStats - Login';
    const metaWithoutCanonical = {
      title,
    };
    const { location } = this.props;
    const pathname = location && location.pathname;
    return addMetaCanonical(metaWithoutCanonical, pathname);
  };

  setRef = (ref, refName) => {
    this[refName] = ref;
  };

  sanitizedEmail = () => (
    this.email.value && this.email.value.trim().toLowerCase()
  );

  handleSubmit = (e) => {
    e.preventDefault();

    const passwordInput = this.password;
    const rememberMe = this.rememberMe;

    this.props.login(this.sanitizedEmail(), passwordInput.value, rememberMe.checked);
  };

  validateEmail = () => {
    if (this.lastKeyPressed !== 13) {
      this.props.resetAuthState();
      if (!isValidEmail(this.sanitizedEmail())) {
        this.setState({
          validEmailStyle: 'red',
        });
      } else {
        this.setState({
          validEmailStyle: null,
        });
      }
    }
    this.lastKeyPressed = null;
  };

  render() {
    const { parsedQs } = this;
    const { user } = this.props;
    const meta = this.getMetaTags();
    const basePath = '/register/plan';
    const signupLink = parsedQs.destination ?
      `${basePath}?destination=${parsedQs.destination}` :
      basePath;

    let error;
    let emailError = '';
    let passwordError = '';

    if (this.props.loginError) {
      const invalidPassword = this.props.loginError.filter(e => e === 'INVALID_PASSWORD');
      if (!invalidPassword) {
        this.email.value = '';
      }
      error = errorDisplayWording(this.props.loginError[0]);
      if (error) {
        switch (error.type) {
          case 'email':
            emailError = error.message;
            break;
          case 'password':
            passwordError = error.message;
            break;
          default:
            break;
        }
      }
    }

    return (
      <div className='login-page-container'>
        <div
          className={`account-panel-content ${this.props.loginError ? 'error' : null}`}
          style={{
            minHeight: '545px',
            display: 'block',
            margin: '0 auto',
          }}
        >
          <Helmet {...meta} />
          <div className='account-content'>
            <h3 className='login-title bold'>Login To FlightStats</h3>
            <IconHeader
              icon={KeyIconWHITE}
              iconStyle={iconHeaderIconStyle}
              onClickSubtitle={(e) => {
                e.preventDefault();
                this.props.routerPush(signupLink);
              }}
              subtitle={
                user ?
                  <span /> :
                  <span className='no-account dotted-underline'>
                    Wait, I need an account!
                  </span>
              }
              title='Login'
            />
            {!user &&
              <div>
                <div className='content'>
                  <form
                    onSubmit={this.handleSubmit}
                    onKeyPress={this.onEnterKeyPress}
                  >
                    <div className='account-form'>
                      <p className='account-form-desc' />
                      <div className='login-email-wrapper'>
                        <TextInput
                          errorMessage={emailError}
                          inputClassName={`account-input ${this.state.validEmailStyle}`}
                          inputRef={ref => this.setRef(ref, 'email')}
                          inputStyle={textInputInputStyle}
                          label='Email Address'
                          labelErrorStyle={textInputLabelErrorStyle}
                          labelStyle={textInputLabelStyle}
                          onInputChange={this.validateEmail}
                          placeholder='name@domain.com'
                          spanStyle={textInputSpanStyle}
                          type='text'
                        />
                        <p className='email-note'>
                          NOTE: THIS EMAIL&nbsp;
                          <span className='dotted-underline bold'>
                            WILL
                          </span>
                          &nbsp;BE THE EMAIL USED DURING REGISTRATION
                        </p>
                      </div>
                      <div className='login-password-wrapper'>
                        <TextInput
                          errorMessage={passwordError}
                          inputClassName='account-input'
                          inputRef={ref => this.setRef(ref, 'password')}
                          inputStyle={textInputInputStyle}
                          label='Password'
                          labelErrorStyle={textInputLabelErrorStyle}
                          labelStyle={textInputLabelStyle}
                          placeholder='•••••••••'
                          spanStyle={textInputSpanStyle}
                          type='password'
                        />
                      </div>
                      <div className='account-secondary-div'>
                        <input
                          type='checkbox'
                          name='rememberMe'
                          ref={ref => this.setRef(ref, 'rememberMe')}
                          defaultChecked
                          style={{ margin: '10px 3px 10px 0', display: 'inline-block' }}
                        />
                        <div
                          className='account-input-title'
                          style={{ display: 'inline-block', paddingLeft: '0', marginLeft: '2px' }}
                        >
                          Remember Me
                        </div>
                        <Link
                          to='/account/forgot-password'
                          className='account-link'
                          style={{ margin: '5px 0', textDecoration: 'underline', float: 'right' }}
                        >
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
                <div className='account-login-bar' />
                <div className='account-login'>
                  <FSFlatButton
                    className='login-submit'
                    label='LOG IN'
                    onClick={this.handleSubmit}
                    style={
                      FSFlatButton.style({
                          margin: '16px 0',
                          padding: '0 50px',
                          minWidth: null,
                          textTransform: 'capitalize',
                        })
                    }
                  />
                </div>
              </div>
            }
            {user &&
              <div className='already-logged-in'>
                <div className='logged-in-content'>
                  <p className='account-description-text'>
                    You are currently logged in as {user.email}.
                  </p>
                </div>
                <div className='account-login-bar' />
                <div className='account-login'>
                  <FSFlatButton
                    label='Log Out'
                    onClick={this.props.logout}
                    style={FSFlatButton.style({ minWidth: '200px', textTransform: 'capitalize' })}
                  />
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Account/components/Login.js